// ── shareText ─────────────────────────────────────────────────────────────────
// One voice for every share. Before this, ~16 surfaces hand-rolled their own
// wording — some said "reels", some "/5", some had no text at all. These helpers
// keep the tone consistent and on-brand: warm, first-person, always naming the
// show and NextEp, and always expressing ratings in the app's signature "reels".

function reels(r) {
  if (!r) return ''
  const n = Math.round(r * 10) / 10
  return `${n} reel${n === 1 ? '' : 's'}`
}

// "Jane thinks you'd love Severance on NextEp (4.5 reels)."
export function showShareText({ showName, rating, sharerName } = {}) {
  const who = sharerName ? `${sharerName} thinks` : 'I think'
  const tail = rating ? ` (${reels(rating)})` : ''
  return `${who} you'd love ${showName} on NextEp${tail}.`
}

// "My NextEp lineup: Severance, The Bear, Shōgun and more. What are you watching?"
export function lineupShareText(names = []) {
  const clean = names.filter(Boolean)
  if (!clean.length) return `My NextEp lineup. What are you watching?`
  const head = clean.slice(0, 3).join(', ')
  const more = clean.length > 3 ? ' and more' : ''
  return `My NextEp lineup: ${head}${more}. What are you watching?`
}

// "I'm watching The Bear on NextEp — watch it with me? 🍿"
export function watchTogetherText({ showName } = {}) {
  return `I'm watching ${showName} on NextEp, watch it with me? 🍿`
}

// "Just finished Severance — 4.5 reels — on NextEp. What should I watch next?"
export function completedShareText({ showName, rating } = {}) {
  const tail = rating ? `, ${reels(rating)},` : ''
  return `Just finished ${showName}${tail} on NextEp. What should I watch next?`
}


export { reels as formatReels }
